// extracted by mini-css-extract-plugin
export default {"PanelContainer":"TestNotificaciones_PanelContainer__zEs0B"};